// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"fd893b10970c113805ee","883":"f1e0885a31fc7ef39bc3"}[chunkId] + ".js";
};